import React, { useEffect, useRef } from "react";

// SASS
import "./Part5.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import orangeGermImg from "../../assets/img/germ-4.svg";
import darkBlueGermImg from "../../assets/img/germ-5.svg";
import purplegermImg from "../../assets/img/germ-3.svg";
import turquoiseGermImg from "../../assets/img/germ-1.svg";
import lightBlueGermImg from "../../assets/img/germ-2.svg";

export default function Part5({ step }) {
  // SCROLLAMA INSTANCE
  const scrolly = scrollama();

  // ANIMATION STEP DATA
  const animationSequence = [
    { stepNumber: "0", height: null, description: "spacer" },
    { stepNumber: "1", height: null, description: "fade background, fade-in germs container, fade in bottom text, fade top text" },
    { stepNumber: "2", height: "1000px", description: "spacer" },
    { stepNumber: "3", height: null, description: "spacer" },
  ];

  // REFS
  const germContainerEl = useRef(null);
  const topTextEl = useRef(null);
  const bottomTextEl = useRef(null);
  const backgroundEl = useRef(null);

  // RUN WHEN THE COMPONENT MOUNTS
  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ element, direction }) => {
        const step = element.dataset.step;
        
        switch (step) {
          case "1": {
            animate.addClassOnEnter(backgroundEl.current, "fade", direction);
            animate.fadeInOnEnter(bottomTextEl.current, direction);
            animate.addClassOnEnter(topTextEl.current, "fade", direction)
            animate.fadeInOnEnter(germContainerEl.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ element, progress }) => {
        switch (step) {
          default:
            break;
        }
      })
      .onStepExit(({ element, direction }) => {
        const step = element.dataset.step;
        switch (step) {
          case "1": {
            animate.removeClassOnExit(backgroundEl.current, "fade", direction);
            animate.fadeOutOnExit(bottomTextEl.current, direction);
            animate.removeClassOnExit(topTextEl.current, "fade", direction)
            animate.fadeOutOnExit(germContainerEl.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // CUSTOM FUNCTIONS

  return (
    <section className="wrapper">
      <div className="sticky-container">
        {/* STICKY */}
        <div className="part5">
          <div className="scene-background" ref={backgroundEl}></div>
          <div className="text text-top" ref={topTextEl}>
            So what surfaces are viruses usually on?
          </div>
          <div className="text text-bottom" ref={bottomTextEl}>More than you might think.</div>
          <div className="germs-container" ref={germContainerEl}>
            <div className="germ germ-1 rotate delay-random-1">
              <img src={orangeGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="germ germ-2 rotate delay-random-2">
              <img src={darkBlueGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="germ germ-3 rotate delay-random-3">
              <img src={darkBlueGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="germ germ-4 rotate delay-random-4">
              <img src={purplegermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="germ germ-5 rotate delay-random-5">
              <img src={orangeGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="germ germ-6 rotate delay-random-6">
              <img src={purplegermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="germ germ-7 rotate delay-random-7">
              <img src={turquoiseGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="germ germ-8 rotate delay-random-8">
              <img src={turquoiseGermImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="germ germ-9 rotate delay-random-9">
              <img src={lightBlueGermImg} alt="Germ" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>

      {/* STEPS */}
      {animationSequence.map(({ stepNumber, height, description }) => {
        return (
          <Step
            stepNumber={stepNumber}
            stepSection={step}
            stepDescription={description}
            height={height}
            key={stepNumber}
          />
        );
      })}
    </section>
  );
}
